var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.667 2.133c0-.442-.329-.8-.734-.8h-13.2c-.405 0-.733.358-.733.8v14.4c0 .442.328.8.733.8h13.2c.405 0 .734-.358.734-.8v-14.4z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.667h4.228c.426 0 .772.377.772.842v14.316c0 .465-.346.842-.772.842H8.105c-.426 0-.772-.377-.772-.843V18.04",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYuNjY2NyAyLjEzMzMxQzE2LjY2NjcgMS42OTE0OSAxNi4zMzgzIDEuMzMzMzEgMTUuOTMzMyAxLjMzMzMxSDIuNzMzMzNDMi4zMjgzMiAxLjMzMzMxIDIgMS42OTE0OSAyIDIuMTMzMzFWMTYuNTMzM0MyIDE2Ljk3NTEgMi4zMjgzMiAxNy4zMzMzIDIuNzMzMzMgMTcuMzMzM0gxNS45MzMzQzE2LjMzODMgMTcuMzMzMyAxNi42NjY3IDE2Ljk3NTEgMTYuNjY2NyAxNi41MzMzVjIuMTMzMzFaIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE3IDYuNjY2NjNIMjEuMjI4MUMyMS42NTQ0IDYuNjY2NjMgMjIgNy4wNDM2NSAyMiA3LjUwODczVjIxLjgyNDVDMjIgMjIuMjg5NiAyMS42NTQ0IDIyLjY2NjYgMjEuMjI4MSAyMi42NjY2SDguMTA1MjZDNy42Nzg5NCAyMi42NjY2IDcuMzMzMzMgMjIuMjg5NiA3LjMzMzMzIDIxLjgyNDVWMTguMDM5MiIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgCopy as ReactComponent };